import axios from '../axiosConfig'; // Assuming this is your configured Axios instance
import { API_BASE_URL } from '../config';
const baseURL = API_BASE_URL;


const nfcAdd = async (data) => {
    var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
    if (! axios.defaults.headers.common["Authorization"]){
      headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
    }
  
    try {
      const response = await axios.post('/nfc/add',data,{
        headers: headers
      });
      console.log(response);
       
      return response;
    } catch (error) { 
      return error;
    }
  }; 
  const nfcAll = async (data) => {
    var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
    if (! axios.defaults.headers.common["Authorization"]){
      headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
    }

    try { 
        const param={
          tag_type:data.tag_type?data.tag_type:'',
          assigned_id:data.assigned_id?data.assigned_id:'',
          page:data.page?data.page:1,
          per_page:data.per_page?data.per_page:10,
        }
      const response = await axios.get('/nfc/all?tag_type='+param.tag_type+'&assigned_id='+param.assigned_id+'&page='+param.page+'&per_page='+param.per_page,{
        headers: headers 
      })
      return response;
    } catch (error) {
      return error;
    }
  }

  const nfcDelete = async (id) => {
    var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
    if (! axios.defaults.headers.common["Authorization"]){
      headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
    }

    try {
      const response = await axios.delete('/nfc/delete/'+id,{
        headers: headers
      });
      console.log(response);

      return response;
    } 
    catch (error) {
      return error; 
    }
  }

  const getNfcByUid = async (uid) => {
    var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
    if (! axios.defaults.headers.common["Authorization"]){
      headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
    }

    try {
      const response = await axios.get('/nfc/get/'+uid,{
        headers: headers
      });
      console.log(response);

      return response;
    } 
    catch (error) {
      return error; 
    }
  }

  const nfcResolve = async (id) => {
    var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
    if (! axios.defaults.headers.common["Authorization"]){
      headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
    }

    try {
      const response = await axios.post('/nfc/resolve/'+id,{
        headers: headers
      });
      console.log(response);

      return response;
    } 
    catch (error) {
      return error;  
    }
  }

  const nfcUpdate = async (id,data) => {
    var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
    if (! axios.defaults.headers.common["Authorization"]){
      headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
    }

    try {
      const response = await axios.put('/nfc/update/'+id,data,{
        headers: headers
      });
      console.log(response);

      return response;  
    } 
    catch (error) {
      return error; 
    }
  }

  
  const userNfcUpdate = async (newuid,olduid) => {
    var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
    if (! axios.defaults.headers.common["Authorization"]){
      headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
    }

    try {
      const response = await axios.put('/nfc/update/usernfc/'+olduid,{new_uid:newuid},{
        headers: headers
      });
      console.log(response);

      return response;  
    } 
    catch (error) {
      return error; 
    }
  }
  /**
   * Get NFC tags for a specific product (customer-friendly endpoint)
   * @param {number} productId - The product ID
   * @returns {Promise<Object>} NFC data for the product
   */
  const getProductNFC = async (productId) => {
    var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
    if (! axios.defaults.headers.common["Authorization"]){
      headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
    }

    try {
      const response = await axios.get(`/nfc/product/${productId}`, {
        headers: headers
      });
      console.log('Product NFC response:', response);
      return response;
    } catch (error) {
      console.error('Error fetching product NFC:', error);
      return error;
    }
  };

  /**
   * Get all products that have NFC tags (customer-friendly endpoint)
   * @param {number} page - Page number (default: 1)
   * @param {number} perPage - Items per page (default: 10)
   * @returns {Promise<Object>} Products with NFC tags
   */
  const getProductsWithNFC = async (page = 1, perPage = 10) => {
    var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
    if (! axios.defaults.headers.common["Authorization"]){
      headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
    }

    try {
      const response = await axios.get(`/nfc/products?page=${page}&per_page=${perPage}`, {
        headers: headers
      });
      console.log('Products with NFC response:', response);
      return response;
    } catch (error) {
      console.error('Error fetching products with NFC:', error);
      return error;
    }
  };

  /**
   * Resolve NFC tag by UID (existing endpoint, updated for better error handling)
   * @param {string} uid - NFC tag UID
   * @returns {Promise<Object>} Resolved NFC data
   */
  const resolveNFC = async (uid) => {
    var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
    if (! axios.defaults.headers.common["Authorization"]){
      headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
    }

    try {
      const response = await axios.post('/nfc/resolve', { uid }, {
        headers: headers
      });
      console.log('NFC resolve response:', response);
      return response;
    } catch (error) {
      console.error('Error resolving NFC:', error);
      return error;
    }
  };

  export  {nfcAdd,nfcAll,nfcDelete,getNfcByUid,nfcResolve,nfcUpdate,userNfcUpdate,getProductNFC,getProductsWithNFC,resolveNFC};